import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface LicenseRemovedBottomSheetProps {
  modalState: UseModalState;
}

export function LicenseRemovedBottomSheet(props: LicenseRemovedBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              modalState.closeModal();
            }}
          >
            Got it!
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent illustrationType="info" title="License has been removed" />
    </BottomSheet>
  );
}
